// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f8242aae","239":"a5319b63","488":"8491a257","732":"fb55dd20","952":"4071e5e6","970":"9e05c3b3"}[chunkId] + ".chunk.js";
};